// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/fargate/76efaba8/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/fargate/76efaba8/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

